import {appsettings} from "../AppSettings"


export default class ConfigService
{
    constructor()
    {
        this.appsettings = appsettings;
    }


    hasKey(key){
        return this.appsettings.some(o => o.key === key);
    }

    getValue(key){
        let obj = this.appsettings.find(o => o.key === key);
        return obj.value;
    }

    getAppVersion()
    {
        return this.getValue("version");
    }

    getAuthServiceHost()
    {
        return this.getValue("glasschain.auth.host.addr");
    }

    getCoreServiceHost()
    {
        return this.getValue("glasschain.core.host.addr");
    }

    getUserScope()
    {
        return this.getValue("user.scope");
    }

    getCustomerLogoImagePath(gcid)
    {
        var result = this.getValue("glasschain.gcid.image.base") +"/" + gcid + "/logos/" + gcid + "-logo.png";
        return result;
    }

}